<template>
  <span v-if="isLoading">&nbsp;</span>
  <img v-else :src="image" :alt="alt ? alt : ''" class="object-cover" />
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import ApiService from '@/services/api.service'

const props = defineProps<{
  uuid: string | null
  alt?: string
  asBase64?: boolean
  fallbackUrl?: string
}>()

const emit = defineEmits(['loaded'])

const image = ref<string | null>(props.fallbackUrl ?? null)

const isLoading = ref<boolean>(true)

onMounted(() => {
  if (!props.uuid || props.uuid.length === 0) {
    isLoading.value = false
    return
  }

  ApiService.documents
    .preview(props.uuid)
    .then((response) => {
      let blob = new Blob([response.data])

      if (props.asBase64) {
        blobToDataUrl(blob).then((result) => (image.value = result))
        return
      }

      image.value = window.URL.createObjectURL(blob)
    })
    .finally(() => {
      isLoading.value = false
      emit('loaded', null)
    })
})

const blobToDataUrl = (blob: Blob) => {
  return new Promise((resolve, _) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result)
    reader.readAsDataURL(blob)
  })
}
</script>
